import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=f8689d58&"
import script from "./MessageCenter.vue?vue&type=script&lang=js&"
export * from "./MessageCenter.vue?vue&type=script&lang=js&"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=f8689d58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports